import './CursuriPresentation.css';
import { Link } from 'react-router-dom';

import bazeleconta from '../imagesHome/bazeleconta.png';
import contafinanciara from '../imagesHome/contafinanciara.png';
import publiccouesespage from '../imagesHome/publiccouesespage.png';
import DownsideBackground from '../firstpage/DownsideBackground';

const CursuriPresentation = () => {
  return (
    <main className="courses-page">

      {/* HERO */}
      <section className="courses-hero">
        <div className="courses-container courses-hero-grid">

          <div className="courses-hero-content">

          

            <h1>
              Invata contabilitate
              <span> pas cu pas.</span>
            </h1>

            <p className="courses-hero-description">
              De la primele notiuni pana la contabilitatea financiara,
              inveti prin explicatii clare, exercitii si aplicatii practice.
            </p>

           

            <div className="courses-hero-actions">
              <Link
                to="/quiz-start"
                href="#cursuri"
                className="courses-btn courses-btn-primary"
              >
                Incepe sa inveti
               
              </Link>

           
            </div>

          </div>

          <div className="courses-hero-visual">

            <div className="courses-visual-decoration decoration-one" />
            <div className="courses-visual-decoration decoration-two" />

            <img
              src={publiccouesespage}
              alt="Invata contabilitate cu ContaLearn"
              className="courses-hero-image"
            />

        

        

          </div>

        </div>
      </section>


      {/* INTRO CURSURI */}
      <section
        className="courses-catalog"
        id="cursuri"
      >
        <div className="courses-container">

          <div className="courses-section-heading">

          

            <h2>
              Alege de unde vrei sa incepi
            </h2>

            <p>
             Invata contabilitatea de la zero, prin explicatii clare, exercitii interactive si exemple practice.
            </p>

          </div>


          {/* CURS 1 */}
          <article className="course-showcase">

            <div className="course-showcase-image course-showcase-green">

            

              <img
                src={bazeleconta}
                alt="Bazele contabilitatii"
              />

            </div>

<div className="course-showcase-content">

  <h3>Bazele contabilitatii</h3>

  <p>
    Invata contabilitatea de la zero, prin explicatii
    clare, exercitii interactive si aplicatii practice.
  </p>

  <div className="course-meta">
    <div>
      <strong>17</strong>
      <span>module</span>
    </div>

    <div>
      <strong>312</strong>
      <span>lectii</span>
    </div>

      <div>
      <strong>nivel</strong>
      <span>Incepator</span>
    </div>

    
  </div>

  <div className="course-learning">

    <h4>Ce vei invata</h4>

    <div className="course-topics">
      <span>✓ Sa identifici elementele patrimoniale</span>
      <span>✓ Sa intelegi functionarea conturilor</span>
      <span>✓ Sa diferentiezi debitul de credit</span>
      <span>✓ Sa construiesti formule contabile</span>
    </div>

  </div>



  <Link
    to="/quiz-start"
    className="course-open-btn"
  >
    Incepe sa inveti
  </Link>

</div>

          </article>


          {/* CURS 2 */}
          <article className="course-showcase course-showcase-reverse">

            <div className="course-showcase-image course-showcase-blue">

             

              <img
                src={contafinanciara}
                alt="Contabilitate financiara"
              />

            </div>

            <div className="course-showcase-content">

             

              <h3>
                Contabilitate financiara
              </h3>

              <p>
                Continua cu operatiuni contabile mai complexe si invata
                cum sunt reflectate tranzactiile unei firme in contabilitate.
              </p>

              <div className="course-meta">

                <div>
                  <strong>150+</strong>
                  <span>lectii</span>
                </div>

                <div>
                  <strong>Intermediar</strong>
                  <span>nivel</span>
                </div>

                <div>
                  <strong>Aplicat</strong>
                  <span>format</span>
                </div>

              </div>

              <div className="course-topics">

                <span>✓ Imobilizari</span>
                <span>✓ Stocuri</span>
                <span>✓ Furnizori si clienti</span>
                <span>✓ Operatiuni financiare</span>

              </div>

              <Link
                to="/quiz-start"
                className="course-open-btn"
              >
                Incepe sa inveti
                
              </Link>

            </div>

          </article>

        </div>
      </section>

         {/* CUM FUNCTIONEAZA CONTALEARN */}
      <section className="courses-how">
        <div className="courses-container">

          <div className="courses-how-heading">
            <h2>Cum functioneaza ContaLearn?</h2>

            <p>
              Trei pasi simpli de la prima lectie
              pana la certificatul tau de competente.
            </p>
          </div>

          <div className="courses-how-grid">

            <article className="courses-how-card">
              <span className="courses-how-number">01</span>

              <h3>Alege cursul potrivit</h3>

              <p>
                Incepe cu bazele contabilitatii sau
                alege un curs potrivit nivelului tau.
                Invata in ritmul tau, de oriunde.
              </p>
            </article>

            <article className="courses-how-card">
              <span className="courses-how-number">02</span>

              <h3>Invata prin exercitii</h3>

              <p>
                Parcurge lectii interactive, rezolva
                quiz-uri si aplica notiunile invatate
                prin exercitii practice.
              </p>
            </article>

            <article className="courses-how-card">
              <span className="courses-how-number">03</span>

              <h3>Obtine certificatul</h3>

              <p>
                Finalizeaza cursul si obtine un
                certificat de competente unic si
                verificabil, care confirma progresul tau.
              </p>
            </article>

          </div>

        </div>
      </section>



<DownsideBackground />
    </main>
  );
};

export default CursuriPresentation;